import Checkbox from '@src/components/common/checkbox/Checkbox';
import { TFilterTag } from '@src/types/weddingHallFilter';
import { HALL_FILTER_DATA } from '@src/utils/weddingHall';

type Item = typeof HALL_FILTER_DATA[keyof typeof HALL_FILTER_DATA][number];
interface ICheckBoxItems {
  items: Item[];
  onSelect: (value: TFilterTag) => void;
  tags: TFilterTag[];
}

const CheckBoxItems = ({ items, onSelect, tags }: ICheckBoxItems) => {
  return (
    <div>
      <ul className="checkbox-list-wrap">
        {items.map((type, idx) => (
          <li key={`checkbox-list-${type.key}-${type.name}`}>
            <Checkbox
              id={`${type.key}-radio-${idx}`}
              name="hallLevel"
              value={type.value as string}
              setValue={_ => {
								const value: TFilterTag = {
									name: type.name,
									typeName: type.typeName,
									paramName: type.key as string,
									value: type.value
								}
                onSelect(value);
              }}
              checked={tags?.some(tag => tag.value === type.value)}
            />
            <label htmlFor={`${type.key}-radio-${idx}`}>{type.name}</label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CheckBoxItems;